export enum PlannerProfileType {
  Private = 'PRIVATE',
  Public = 'PUBLIC',
}
